export default __webpack_public_path__ + "static/media/icon_histpedidos.a4e88aae.svg";